import { render } from "./Urgent.vue?vue&type=template&id=f9fce8bc&scoped=true"
import script from "./Urgent.vue?vue&type=script&lang=js"
export * from "./Urgent.vue?vue&type=script&lang=js"

import "./Urgent.vue?vue&type=style&index=0&id=f9fce8bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fce8bc"]])

export default __exports__